<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Change Role</p>
      </header>
      <section class="modal-card-body">
        <b-field
          label="Role"
          :type="('role' in errors) ? 'is-danger' : ''"
          :message="('role' in errors) ? errors['role'][0] : ''"
          expanded>
          <b-select
            placeholder="Select a role"
            size="is-medium"
            expanded
            v-model="role">
            <option value="administrator">Administrator</option>
            <option value="lead">Lead</option>
            <option value="member">Member</option>
          </b-select>
        </b-field>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <b-button
          type="is-primary"
          native-type="submit"
          :loading="saving"
          :disabled="saving"
        >Save</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['api']),
    endpoint () {
      return this.api.route + '/admin/roles/' + this.current.id
    },
    json () {
      return {
        email: this.email,
        role: this.role
      }
    }
  },
  methods: {
    save () {
      this.saving = true
      this.$http.patch(this.endpoint, this.json).then(response => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Team member updated!' })
        this.$parent.close()
        this.$emit('role:saved', response.data.id)
      }).catch(error => {
        this.errors = error.response.data.errors
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again.' })
      }).finally(() => {
        this.saving = false
      })
    }
  },
  data () {
    return {
      role: null,
      saving: false,
      errors: []
    }
  },
  mounted () {
    this.role = this.current.role
  },
  props: ['current']
}
</script>
